import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';

import './styles.scss';

export default function FaturamentoProduto({ source }) {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    if (!source?.representadas) return;

    let produtos = source.faturamentoProdutos.map((x) => x.nome);
    let faturamento = source.faturamentoProdutos.map((x) => x.valorFaturado);

    let chartData = {
      series: [
        {
          name: '', // Nome da série
          data: faturamento
        }
      ],
      options: {
        chart: {
          type: 'bar',
          height: 350
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },

        dataLabels: {
          enabled: false
        },

        xaxis: {
          categories: produtos,
          labels: {
            formatter: function (val) {
              // Formate os valores do eixo X para milhares
              return val / 1000 + 'k';
            }
          }
        },

        tooltip: {
          y: {
            formatter: function (val) {
              // Formate os valores na tooltip para moeda brasileira (BRL)
              return (
                '<span style="font-size: 4px">' +
                new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(val) +
                '</span>'
              );
            }
          }
        },

        fill: {
          colors: ['#1244b7']
        }
      }
    };

    setChartData(chartData);
  }, [source]);

  if (!chartData) return null;

  return (
    <div id="chart">
      <h3 className="mb-2 text-gray-800">Faturamento Produto</h3>
      <ReactApexChart
        options={chartData.options}
        series={chartData.series}
        type="bar"
        height={500}
      />
    </div>
  );
}
